'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.action = exports.computed = exports.observable = exports.exec = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _ajax = require('../utils/ajax');

var _ajax2 = _interopRequireDefault(_ajax);

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _isPlainObject = require('../core/isPlainObject');

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _crud = require('./crud');

var _crud2 = _interopRequireDefault(_crud);

var _action2 = require('../seed/action');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getReducer(reducer, curdOpt) {
  var callback = void 0;
  if ((0, _isPlainObject2.default)(reducer)) {
    callback = {};

    var _loop = function _loop(key) {
      callback[key] = function (nextStore, payload, initialState, currentState, opt) {
        return reducer[key].call(this, nextStore, payload, initialState, currentState, curdOpt || opt);
      };
    };

    for (var key in reducer) {
      _loop(key);
    }
  } else {
    callback = function callback(nextStore, payload, initialState, currentState, opt) {
      return reducer.call(this, nextStore, payload, initialState, currentState, curdOpt || opt);
    };
  }
  return callback;
}
// see: https://github.com/jayphelps/core-decorators
/**
 * curdOpt = {
 *  isGenarator,
 *  exec,
 *  id,
 *  processData
 * }
 */
/**
 * # Model基类
 * 1. 每个Model在Store中都存在modelName所对应的数据域，即通过state.modelName返回Model所对应的所有数据。
 * 2. Model的实现基于事件机制，方便绑定自定义事件
 */
var exec = exports.exec = function exec(name, feedback, curdOpt) {
  return function (model, actionName, descriptor) {
    var reducer = descriptor.initializer ? descriptor.initializer() : descriptor.value;
    descriptor.initializer = undefined;
    descriptor.value = function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var action = this._actions[actionName];
      if (!feedback && action && (action.exec.successMessage || action.exec.errorMessage)) {
        feedback = _crud2.default.message(action.exec.successMessage, action.exec.errorMessage);
      }
      // #! exce(String) 走model.actionName调用并且更新数据到指定name属性
      if (typeof name === 'string') {
        if (feedback) {
          args.push(feedback);
        }
        if (curdOpt && curdOpt.exec || action) {
          return this.setState.apply(this, [(0, _defineProperty3.default)({}, name, {
            exec: curdOpt && curdOpt.exec || actionName,
            callback: getReducer(reducer, curdOpt)
          })].concat(args));
        } else {
          return this.setState.apply(this, [(0, _defineProperty3.default)({}, name, new Promise(function (resolve) {
            return resolve((0, _isPlainObject2.default)(reducer) ? reducer : getReducer(reducer, curdOpt).apply(_this, args));
          }))].concat(args));
        }
      } else if (name !== undefined) {
        // #! exec(null|false)
        var _action = curdOpt || {};
        if (_action.exec) {
          _action.callback = getReducer(reducer, curdOpt);
        } else {
          _action = getReducer(reducer, curdOpt);
        }
        // #! name === false 则只走model.actionName调用不更新数据，否则是根据返回结构更新数据
        var promise = this.execute.apply(this, [actionName, _action, name === false].concat(args));
        promise.then(function (ret) {
          if (feedback) {
            if (ret instanceof Error) {
              feedback(ret);
            } else {
              feedback(null, ret);
            }
          }
        }, function (err) {
          feedback && feedback(err);
        });
        return this.fromPromise(promise);
      }
    };
    return descriptor;
  };
};

var observable = exports.observable = function observable(target, name, descriptor) {
  target.state = target.state || {};
  target.state[name] = descriptor.initializer.call(target);
  return {
    set: function set(v) {
      this.state[name] = v;
    },

    enumerable: false
  };
};

var computed = exports.computed = function computed(target, name, descriptor) {
  target.state = target.state || {};
  var method = descriptor.get;
  Object.defineProperty(target.state, name, {
    get: function get() {
      return method.call(target);
    },

    enumerable: true,
    configuration: true
  });
  return descriptor;
};

var action = exports.action = function action(target, name, descriptor) {
  var method = descriptor.value;
  descriptor.value = function () {
    var _this2 = this;

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var ret = method.apply(this, args);
    if (ret && ret.then) {
      ret.then(function (ret) {
        if (!(ret instanceof Error)) {
          _this2.dispatch({
            type: _this2.ACTION_TYPE_IMMEDIATE,
            payload: _this2.state
          });
        }
      }, function () {
        // handler
      });
    } else {
      this.dispatch({
        type: this.ACTION_TYPE_IMMEDIATE,
        payload: this.state
      });
    }
  };
  return descriptor;
};

var BaseModel = function () {
  /**
   * option = {
   *  name,
   *  ajax,
   *  isImmutable
   * }
   */
  function BaseModel() {
    var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, BaseModel);

    this._name = option.name;
    this.ajax = option.ajax || new _ajax2.default();
    this._isImmutable = option.isImmutable;
    this._actions = option.actions || {};
    this._saga = option.saga;
  }

  (0, _createClass3.default)(BaseModel, [{
    key: '_wrapperReducer',
    value: function _wrapperReducer(name, reducer, action) {
      var _this3 = this;

      if ((0, _isPlainObject2.default)(reducer)) {
        var map = {};

        var _loop2 = function _loop2(status) {
          map[status] = function (nextStore, payload) {
            nextStore[name] = reducer[status].call(_this3, nextStore, payload, _this3._initialState[name], _this3.state[name], action);
          };
        };

        for (var status in reducer) {
          _loop2(status);
        }
        return map;
      } else {
        reducer = action.callback || reducer;
        return function (nextStore, payload) {
          nextStore[name] = reducer.call(_this3, nextStore, payload, _this3._initialState[name], _this3.state[name], action);
        };
      }
    }
  }, {
    key: 'setState',
    value: function setState(nextState) {
      var callback = void 0;

      for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }

      if (typeof args[args.length - 1] === 'function') {
        callback = args[args.length - 1];
        args.pop();
      }
      var promises = [];
      var getData = function getData(nextState, payload) {
        return payload.data;
      };
      for (var key in nextState) {
        switch (true) {
          case nextState[key] !== undefined && nextState[key].asMutable:
            nextState[key] = {
              data: this._isImmutable ? nextState[key] : nextState[key].asMutable({ deep: true }),
              callback: this._wrapperReducer(key, getData, {})
            };
            break;
          case !!(nextState[key] && nextState[key].then):
            nextState[key] = {
              exec: nextState[key],
              callback: this._wrapperReducer(key, getData, {})
            };
            break;
          default:
            if (typeof nextState[key] === 'function') {
              var _callback = nextState[key];
              // nextState[key] = crudOpt
              if (_callback.name === key) {
                nextState[key] = {
                  callback: this._wrapperReducer(key, _callback, nextState[key])
                };
              } else if (this._actions[_callback.name]) {
                nextState[key] = (0, _cloneDeep2.default)(this._actions[_callback.name]);
                nextState[key].callback = this._wrapperReducer(key, _callback || getData, nextState[key]);
              } else {
                nextState[key] = {
                  callback: _callback
                };
                nextState[key].callback = this._wrapperReducer(key, _callback, nextState[key]);
              }
              // nextState[key] = crudOpt
            } else if (nextState[key].exec) {
              var _callback2 = nextState[key].callback;
              if (typeof nextState[key].exec === 'string') {
                if (this._actions[nextState[key].exec]) {
                  nextState[key] = (0, _cloneDeep2.default)(this._actions[nextState[key].exec]);
                }
                _callback2 = _callback2 || nextState[key].callback;
                delete nextState[key].callback;
              }
              nextState[key].callback = this._wrapperReducer(key, _callback2 || getData, nextState[key]);
            } else {
              nextState[key] = {
                data: nextState[key],
                callback: this._wrapperReducer(key, getData, {})
              };
            }
            break;
        }
        nextState[key].cid = this.id || 'id';
        args.unshift(false);
        args.unshift(nextState[key]);
        args.unshift(nextState[key].name || key);
        promises.push(this.execute.apply(this, args));
      }

      var promise = Promise.all(promises);
      promise = promise.then(function (datas) {
        var keys = Object.keys(nextState);
        var data = void 0;
        var i = 0;
        if (keys.length > 1) {
          data = {};
          for (var len = keys.length; i < len; i++) {
            if (datas[i] instanceof Error) {
              data = datas[i];
              break;
            } else {
              data[keys[i]] = datas[i];
            }
          }
        } else {
          data = datas[i];
        }

        if (callback) {
          if (data instanceof Error) {
            callback(data);
          } else {
            callback(null, data);
          }
        }
        return data;
      }, function (err) {
        callback && callback(err);
      });

      return this.fromPromise(promise);
    }
  }, {
    key: 'fromPromise',
    value: function fromPromise(promise) {
      promise.subscribe = function (callback) {
        if (callback) {
          promise.then(function (res) {
            if (res instanceof Error) {
              callback(res);
            } else {
              callback(null, res);
            }
          }, callback);
        }
        return promise;
      };
      return promise;
    }

    /**
     * action可以是function
     * action或者是对象 = {
     *  callback,
     *  exec, // 接口调用的描述，afterResponse可以对数据预处理
     *  isGenerator
     * }
     */

  }, {
    key: 'execute',
    value: function execute(name, action, noDispatch) {
      var _this4 = this;

      if (!this._initialState) {
        this._initialState = (0, _cloneDeep2.default)(this.state);
      }
      if (this._actions[name] && this.state[name] === undefined && !action.exec) {
        var _callback = action;
        action = (0, _cloneDeep2.default)(this._actions[name]);
        action.callback = _callback || action.callback;
      }
      var processor = void 0;
      var async = void 0;
      if (action.exec) {
        processor = (0, _action2.getProcessorByExec)(this, this._initialState, this._name, name, action.exec, this.ajax, noDispatch);
        async = true;
      } else if (action.isGenerator) {
        processor = (0, _action2.getProcessorByGenerator)(this, this._initialState, this._name, name, this._saga, noDispatch);
      } else {
        processor = (0, _action2.getProcessor)(this, this._initialState, this._name, name, action, function () {
          return _this4.state;
        }, noDispatch);
      }
      if (!noDispatch) {
        (0, _action2.setReducers)(this, this._name, name, action, async);
      }

      for (var _len4 = arguments.length, args = Array(_len4 > 3 ? _len4 - 3 : 0), _key4 = 3; _key4 < _len4; _key4++) {
        args[_key4 - 3] = arguments[_key4];
      }

      return processor.apply(this, args)(this.dispatch);
    }
  }]);
  return BaseModel;
}();

exports.default = BaseModel;


//////////////////
// WEBPACK FOOTER
// ./src/damo/baseModel.js
// module id = 31
// module chunks = 0